import { faCopy } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import Snackbar from '@sorare/core/src/atoms/snackbar/Snackbar';
import { LabelM } from '@sorare/core/src/atoms/typography';
import useCopyToClipboard from '@sorare/core/src/hooks/useCopyToClipboard';
import { glossary } from '@sorare/core/src/lib/glossary';

import { ButtonText } from 'components/rivalsUserGroup/Settings/ui';

type Props = {
  joinSecret: string;
};

export const LeagueCode = ({ joinSecret }: Props) => {
  const [copiedSnackbarOpen, setCopiedSnackbarOpen] = useState(false);
  const copyToClipboard = useCopyToClipboard();
  const { formatMessage } = useIntl();
  const onCopyCode = () => {
    copyToClipboard(joinSecret);
    setCopiedSnackbarOpen(true);
  };

  return (
    <>
      <Button size="large" color="transparent" onClick={onCopyCode} fullWidth>
        <ButtonText>
          <FormattedMessage
            id="RivalsUserGroup.Settings.privateLeagueCode"
            defaultMessage="Private League Code"
          />
        </ButtonText>
        <Horizontal center>
          <LabelM color="var(--c-neutral-600)">{joinSecret}</LabelM>
          <FontAwesomeIcon icon={faCopy} />
        </Horizontal>
      </Button>
      <Snackbar
        autoHideDuration={2000}
        open={copiedSnackbarOpen}
        onClose={() => {
          setCopiedSnackbarOpen(false);
        }}
        message={formatMessage(glossary.copiedToClipboard)}
      />
    </>
  );
};
